function ShareIcon({onClick}) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      onClick={onClick}
    >
      <path
        d="M12.5934 6.74348C6.72782 7.04893 2.01074 11.9174 2.01074 17.8573V21.9967L3.49172 18.5489C5.24329 15.0464 8.71849 12.8069 12.5934 12.601V17.3385L21.9907 9.65679L12.5934 2.00293V6.74348Z"
        fill="#3C4852"
      />
    </svg>
  );
}

export default ShareIcon;
